'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-107/node_modules/@eliadmin/core/src/pages/(profile)/layout.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-107/node_modules/@eliadmin/core/src/pages/(profile)/layout.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/7733fae24264"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

